export default __webpack_public_path__ + "static/eventImg3-f2ef85374dfe53e01502918b844f2e2f.svg";